import { getDefaultPromise } from '../../utils';
export var DEFAULT_IGNORE_TAGS = ['SCRIPT', 'STYLE', 'META', 'HEAD'];
export var ERROR_RELATED_TYPE = ['js_error', 'http', 'resource_error'];
export var DEFAULT_THRESHOLD = 1.5;
export var MAX_RENDER_TIME = 10000;
export var MAX_CHECK_TIME = 8000;
export var DEFAULT_CHECK_TIME = 2000;
export var MAX_RELATED_TIME = 10000;
export var getRequestIdleCallback = function (win) {
    return (win.requestIdleCallback ||
        function (cb) {
            return win.setTimeout(cb, 1);
        });
};
export var blankErrorCompare = function (relatedError, ev) {
    if (ERROR_RELATED_TYPE.indexOf(ev.ev_type) === -1)
        return relatedError;
    if (ev.ev_type === 'http' && ev.payload.response.status < 400) {
        return relatedError;
    }
    if (relatedError && ERROR_RELATED_TYPE.indexOf(relatedError.type) < ERROR_RELATED_TYPE.indexOf(ev.ev_type)) {
        return relatedError;
    }
    var message = '';
    switch (ev.ev_type) {
        case 'js_error':
            message = ev.payload.error.message;
            break;
        case 'http':
            message = ev.payload.request.url;
            break;
        case 'resource_error':
            message = ev.payload.url;
            break;
        default:
            break;
    }
    return { type: ev.ev_type, message: message, timestamp: Date.now() };
};
export var measure = function (element, depth, sum, threshold, ignoreTags) {
    if (depth === void 0) { depth = 0; }
    if (sum === void 0) { sum = 0; }
    if (threshold === void 0) { threshold = DEFAULT_THRESHOLD; }
    if (ignoreTags === void 0) { ignoreTags = DEFAULT_IGNORE_TAGS; }
    if (!element || ignoreTags.indexOf(element.tagName) > -1 || sum >= threshold || depth > 4) {
        return sum;
    }
    var score = (function () {
        if (!depth)
            return 0;
        var _a = element.getBoundingClientRect(), top = _a.top, height = _a.height;
        return top > innerHeight || height <= 0 ? 0 : 1 / Math.pow(2, depth - 1);
    })();
    return [].reduceRight.call(element.children, function (all, child) { return measure(child, depth + 1, all, threshold, ignoreTags); }, sum + score);
};
export var screenshot = function (cb, screenshotUrl, window, document) {
    var _a;
    if (!getDefaultPromise() || !window || !document) {
        return;
    }
    function onload() {
        var requestIdleCallback = getRequestIdleCallback(window);
        requestIdleCallback(function () {
            void window.html2canvas(document.body, { scale: 360 / window.innerWidth }).then(function (canvas) {
                cb(canvas.toDataURL('image/jpeg', 0.1));
            });
        });
    }
    if (window.html2canvas) {
        return onload();
    }
    var script = document.createElement('script');
    script.src = screenshotUrl;
    (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(script);
    script.onload = onload;
};
//# sourceMappingURL=util.js.map